// Client-side mirror of backend pricing.compute_suggested_price(currency="CAD")
// so the share-link edit panel can preview CAD live while the admin types.
// Keep in sync with /app/backend/pricing.py.
export function computeCadPrice({ purchasePrice, entry, product, rates, qty40ftOverride, dutyRate }) {
  const cost = Number(purchasePrice);
  if (purchasePrice == null || purchasePrice === "" || Number.isNaN(cost)) return null;
  const margin = (Number(rates?.profit_margin_rate) || 0) / 100;
  if (margin >= 1) return null;
  const rebate = (Number(product?.tax_rebate_rate) || 0) / 100;
  const duty = (Number(dutyRate ?? product?.customs_duty_rate) || 0) / 100;
  const usdToRmb = Number(rates?.usd_to_rmb_rate);
  const usdToCad = Number(rates?.usd_to_cad_rate);
  const seaFreight = Number(rates?.sea_freight_per_container) || 0;
  const pcs = Number(entry?.pcs_per_ctn);
  const L = Number(entry?.carton_length), W = Number(entry?.carton_width), H = Number(entry?.carton_height);

  let qtyHq = null;
  const override = qty40ftOverride === undefined ? entry?.qty_40ft : qty40ftOverride;
  if (override != null && override !== "" && !Number.isNaN(Number(override))) {
    qtyHq = Number(override);
  } else if (L && W && H && pcs) {
    qtyHq = (65_000_000 * pcs) / (L * W * H);
    const cr = Number(product?.compression_rate) || 0;
    if (cr && cr !== 1) qtyHq = qtyHq / cr;
  }
  if (qtyHq != null) qtyHq = Math.floor(qtyHq);

  if (qtyHq && pcs && usdToRmb && usdToCad) {
    if (qtyHq <= 0) return null;
    const landedUsd = (cost / usdToRmb / (1 + rebate)) * (1 + duty) + seaFreight / qtyHq;
    return Math.round((landedUsd / (1 - margin)) * usdToCad * 100) / 100;
  }
  const divisor = product?.is_bulky ? 2.7 : 3;
  return Math.round((cost / divisor) * 100) / 100;
}
